import React from 'react';
import styled from 'styled-components';
import { useLanguage } from '../LanguageContext';

const Section = styled.section`
  padding: 4rem 1rem;
  max-width: 1200px;
  margin: 0 auto;
  background-color: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.grayDark};
`;

const Title = styled.h2`
  text-align: center;
  font-size: 2rem;
  margin-bottom: 3rem;
  font-family: ${({ theme }) => theme.fonts.primary};
  color: ${({ theme }) => theme.colors.greenPrimary};
`;

const CardsContainer = styled.div`
  display: flex;
  gap: 2rem;
  flex-wrap: wrap;
  justify-content: center;
`;

const Card = styled.div`
  background-color: ${({ theme }) => theme.colors.grayLight};
  border-radius: 10px;
  padding: 1.5rem;
  flex: 1 1 300px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const ClientName = styled.h3`
  font-size: 1.2rem;
  margin-bottom: 0.5rem;
  color: ${({ theme }) => theme.colors.blueLight};
  font-family: ${({ theme }) => theme.fonts.primary};
`;

const Testimonial = styled.p`
  font-size: 1rem;
  margin-bottom: 1rem;
  font-style: italic;
  font-family: ${({ theme }) => theme.fonts.primary};
`;

const ImpactData = styled.p`
  font-weight: 600;
  color: ${({ theme }) => theme.colors.greenPrimary};
  margin-bottom: 1rem;
  font-family: ${({ theme }) => theme.fonts.primary};
`;

const LogoPlaceholder = styled.div`
  width: 80px;
  height: 40px;
  background-color: ${({ theme }) => theme.colors.greenPrimary};
  border-radius: 6px;
  align-self: flex-start;
  color: ${({ theme }) => theme.colors.white};
  font-weight: 700;
  font-size: 0.9rem;
  display: flex;
  align-items: center;
  justify-content: center;
  user-select: none;
`;

const Button = styled.button`
  background-color: ${({ theme }) => theme.colors.greenPrimary};
  color: ${({ theme }) => theme.colors.white};
  border: none;
  padding: 0.5rem 1.5rem;
  font-weight: 600;
  border-radius: 30px;
  transition: background-color 0.3s ease;
  align-self: center;
  margin-top: 2rem;
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => theme.colors.blueLight};
  }
`;

const Cases = () => {
  // Temporarily hidden success cases section
  // TODO: Uncomment when ready to display success cases
  /*
  const { translations } = useLanguage();

  return (
    <Section>
      <Title>{translations.cases.title}</Title>
      <CardsContainer>
        {translations.cases.cards.map((c) => (
          <Card key={c.name}>
            <ClientName>{c.name}</ClientName>
            <Testimonial>"{c.testimonial}"</Testimonial>
            <ImpactData>{c.impact}</ImpactData>
            <LogoPlaceholder>{c.logoLabel}</LogoPlaceholder>
          </Card>
        ))}
      </CardsContainer>
      <Button>{translations.cases.button}</Button>
    </Section>
  );
  */
  return null;
};

export default Cases;
